import { useUser } from "@/context/useUser";
import { getAccessToken } from "@/lib/storeManager";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedRouter = () => {
  const { isAuthenticated } = useUser();
  const isLoggedIn = getAccessToken() !== null;

  return isAuthenticated || isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to="/glucera/onboardingLoginpage" />
  );
};

export default ProtectedRouter;
